// import BaseFormPresenter from "../../../../base/BaseFormPresenter";

import { Button, dialog } from "nq-component";
import BaseFormPresenter from "../../../../components/common/BaseFormPresenter";
import { findObjectUseCase, upsertUseCase } from "../../../../usecases/object";
import { SubmitImg } from "../../../../components/common/Converter";
import { v4 as uuidv4 } from "uuid";
import { createNotification } from "../../../../createNotification";
import { findCurrentUserEmployee, buildHierarchyWhere } from "../../../../utils/hierarchy";

class OfficeFormPresenter extends BaseFormPresenter {
  onChangeObject(object) {
    this.change = object;
    this.object = object;
  }

  onChange(value, field) {
    this.change[field] = value;
    this.object[field] = value;
    this.view.setObject(this.object);
  }

  async getObject() {
    const collection = this.view.getCollectionName();
    const id = this.object.id || this.view.getObjectId();

    try {
      const employees = await findCurrentUserEmployee(
        findObjectUseCase(),
        this.view.getCurrentUser(),
      );
      this.view.setWhere(buildHierarchyWhere(employees?.[0]));
    } catch (error) {
      this.view.setWhere({});
      this.showError(error);
    }

    if (id) {
      const params = { include: ["all", "assignedEmployee", "employee"] };
      try {
        this.view.showProgress();
        this.object = await this.getObjectUseCase.execute(collection, id, {
          params,
        });
        this.view.hideProgress();
        this.view.setObject(this.object);
      } catch (error) {
        this.view.hideProgress();
        this.view.showError(error);
      }
    }
  }

  handleAddRow() {
    this.view.setState({
      output: "",
      successindicators: "",
      actualaccomplishments: "",
      distribution: "",
      quality: "",
      efficiency: "",
      timeliness: "",
      remarks: "",
      addRow: true,
      indexToEdit: null,
      object: {},
      selectedFiles: [],
      modifyFiles: [],
    });
  }

  // async getAssigned(filteredObject) {
  //   const query = {
  //     where: {
  //       id: filteredObject[0]?.id,
  //     },
  //     include: ["all"],
  //   };
  //   const find = await findObjectUseCase().execute("ipcr", query);
  //   this.view.setState({ findEmp: find });
  // }

  handleAddData() {
    const primaryObject = this.view.state;
    const distributionDecimal = parseFloat(primaryObject.distribution) / 100;
    const scores = [
      parseFloat(primaryObject?.quality),
      parseFloat(primaryObject?.efficiency),
      parseFloat(primaryObject?.timeliness),
    ];

    const validScore = scores.filter((score) => !isNaN(score));
    const sum = validScore.reduce((sum, item) => sum + item, 0);
    const average = validScore.length > 0 ? sum / validScore.length : 0;

    const ave = average * distributionDecimal;
    const averagedeci = ave.toFixed(2);
    const data = {
      output: primaryObject.output,
      successindicators: primaryObject.successindicators,
      actualaccomplishments: primaryObject.actualaccomplishments,
      distribution: primaryObject.distribution,
      quality: primaryObject.quality,
      efficiency: primaryObject.efficiency,
      timeliness: primaryObject.timeliness,
      average,
      averagedeci,
      remarks: primaryObject.remarks,
    };

    if (primaryObject.indexToEdit !== null) {
      const updatedForm = primaryObject.ipcrForm.map((item, index) =>
        index === primaryObject.indexToEdit ? data : item
      );
      this.view.setState({
        ipcrForm: updatedForm,
        addRow: false,
        indexToEdit: null,
      });
    } else {
      this.view.setState((prevState) => ({
        ipcrForm: [...prevState.ipcrForm, data],
        addRow: false,
      }));
    }
  }

  // submit form
  async handleFormSubmit() {
    const objectID = uuidv4();
    if (this.view.state.ipcrForm.length === 0) {
      this.showError("Add at least 1 row data");
    } else {
      const currentUser = this.view.state.assignedEmployee;
      const employee = await findObjectUseCase().execute("employees", {
        where: currentUser,
      });

      const noSupervisorAssigned = employee.every((emp) => !emp.supervisor);
      if (noSupervisorAssigned) {
        this.showError("No Supervisor Assigned");
        return;
      }
      const data = {
        id: objectID,
        periodFrom: this.view.state.periodFrom,
        periodTo: this.view.state.periodTo,
        employee: { id: this.view.getCurrentUser().employee.id },
        supervisor: { id: employee[0].supervisor.id },
        performance: this.view.state.ipcrForm,
        assignedEmployee: { id: this.view.state.assignedEmployee.id },
        headPosition: this.view.state.headPosition,
        headName: this.view.state.headName,
        finalPosition: this.view.state.finalPosition,
        finalName: this.view.state.finalName,
      };
      dialog.fire({
        html: (
          <div className="p-2">
            <h4>Confirmation</h4>
            <hr />
            <p style={{ margin: "2rem 0" }}>Click confirm to proceed.</p>
            <hr />
            <div className="w-100 d-flex justify-content-end gap-4 mb-3">
              <Button
                className="btn btn-light fs-sm"
                onClick={() => dialog.close()}
              >
                Cancel
              </Button>
              <Button
                onClick={async () => {
                  if (this.view.getObjectId() !== undefined) {
                    data.id = this.view.getObjectId();
                  }
                  const ArrayFile = await SubmitImg(
                    this.view.state.selectedFiles
                  );
                  const ArrayFile2 = await SubmitImg(
                    this.view.state.modifyFiles || []
                  );
                  data.selectedFiles = ArrayFile;
                  data.modifyFiles = ArrayFile2;
                  data.type = "IPCR";
                  try {
                    await upsertUseCase().execute("ipcr", data);
                    await upsertUseCase().execute("performance", data);

                    dialog.close();
                    this.showSuccess(
                      "You have successfully submitted the performance record."
                    );
                    //  CREATE NOTIFICATION
                    const NOTIFICATION_MESSAGE =
                      "You have a new Performance Request submitted for approval in the My Performances section.";
                    const NOTIFICATION_RECEIVER = [
                      "role:Supervisor",
                      "role:Super Admin",
                    ];
                    const NOTIFICATION_REDIRECT = "performance";

                    createNotification(
                      NOTIFICATION_MESSAGE,
                      NOTIFICATION_RECEIVER,
                      NOTIFICATION_REDIRECT
                    );
                  } catch (e) {
                    this.showError(e.message || e);
                  }
                }}
                className="btn btn-primary"
              >
                Confirm
              </Button>
            </div>
          </div>
        ),
        footer: false,
      });
    }
  }
}

export default OfficeFormPresenter;
